import httpClient from './httpClient';


const getInfosMeta = () => httpClient.get('/infometas');

const getAllMedias = (payload, key) => httpClient.post('/search', payload, {headers : {'key': key}});

const getMediaById = (mediaId, key) => httpClient.get('/get/'+mediaId, {headers : {'key': key}});

const postMedia = (payload, key) => httpClient.post('/upload', payload, {headers : {'key': key}});

const updateMediaById = (mediaId, payload, key) => httpClient.post('/update/'+mediaId, payload, {headers : {'key': key}})

const deleteMedia = (mediaId, key) => httpClient.get('/delete/'+mediaId, {headers : {'key' : key}});

export {
    getInfosMeta, getAllMedias, getMediaById, updateMediaById, postMedia, deleteMedia
}